import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './style/reset.scss';
import './style/element-variables.scss';
import '@/directives/clicklog';
import VueCompositionAPI from '@vue/composition-api';
// import tracking from 'visual-tracking';
import {
    Button,
    Select,
    Form,
    Input,
    FormItem,
    Step,
    Steps,
    Upload,
    Col,
    Row,
    Checkbox,
    Image,
    Option,
    DatePicker,
    Dialog
} from 'element-ui';

Vue.config.productionTip = false;

// Vue.use(tracking, '请输入pageType');
Vue.use(VueCompositionAPI);
//
Vue.use(Button);
Vue.use(Select);
Vue.use(Form);
Vue.use(Input);
Vue.use(FormItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Upload);
Vue.use(Col);
Vue.use(Row);
Vue.use(Checkbox);
Vue.use(Image);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Dialog);
//

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app');
